import { PointCardCreatePage } from './pointCard.create.page';

export default PointCardCreatePage;
